<template>
  <div>
    <b-card title="Dados do contrato">
      <b-row>
        <b-col cols="12" class="mb-1">
          <div class="d-flex" v-if="loading">
            <b-skeleton animation="wave" width="15%" class="mr-1"></b-skeleton>
            <b-skeleton animation="wave" width="15%"></b-skeleton>
          </div>
          <div v-else>
            <b-badge variant="primary" class="mr-1">
              <a :href="mountURLProposal" target="_blank">
                Abrir Proposta do plano
              </a>
            </b-badge>

            <b-badge variant="primary" v-if="this.isTrasnfOrPort">
              <a :href="mountURLDeclarationHealth" target="_blank">
                Abrir Declaração de saúde
              </a>
            </b-badge>
          </div>
        </b-col>
        <b-col
            cols="12"
        >
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="6">
              <table class="mt-2 mt-xl-0 w-100">
                <tr>
                  <b-skeleton animation="wave" v-if="loading"/>
                  <template v-else>
                    <th class="pb-50">
                      <feather-icon
                          icon="UserIcon"
                          class="mr-75"
                      />
                      <span class="font-weight-bold">Nome do plano:</span>
                    </th>
                    <td class="pb-50">
                      {{namePlan}}
                    </td>
                  </template>
                </tr>
                <tr>
                  <b-skeleton animation="wave" v-if="loading"/>
                  <template v-else>
                    <th class="pb-50">
                      <feather-icon
                          icon="InfoIcon"
                          class="mr-75"
                      />
                      <span class="font-weight-bold">Registro ANS:</span>
                    </th>
                    <td class="pb-50 text-capitalize">
                      {{registerANS}}
                    </td>
                  </template>
                </tr>
                <tr>
                  <b-skeleton animation="wave" v-if="loading"/>
                  <template v-else>
                    <th class="pb-50">
                      <feather-icon
                          icon="UserIcon"
                          class="mr-75"
                      />
                      <span class="font-weight-bold">Entidade: </span>
                    </th>
                    <td class="pb-50 text-capitalize">
                      {{entityName}}
                    </td>
                  </template>
                </tr>
                <tr>
                  <b-skeleton animation="wave" v-if="loading"/>
                  <template v-else>
                    <th class="pb-50">
                      <feather-icon
                          icon="CalendarIcon"
                          class="mr-75"
                      />
                      <span class="font-weight-bold">Data de vigência:</span>
                    </th>
                    <td class="pb-50">
                      {{effectiveDate}}
                    </td>
                  </template>
                </tr>
                <tr>
                  <b-skeleton animation="wave" v-if="loading"/>
                  <template v-else>
                    <th class="pb-50">
                      <feather-icon
                          icon="InfoIcon"
                          class="mr-75"
                      />
                      <span class="font-weight-bold">Acomodação:</span>
                    </th>
                    <td>
                      {{acomodation}}
                    </td>
                  </template>
                </tr>
              </table>
            </b-col>
            <b-col cols="6" sm="12" md="6" lg="6">
              <table class="mt-2 mt-xl-0 w-100">
                <tr>
                  <b-skeleton animation="wave" v-if="loading"/>
                  <template v-else>
                    <th class="pb-50">
                      <feather-icon
                          icon="MapIcon"
                          class="mr-75"
                      />
                      <span class="font-weight-bold">Abrangência Geografica: </span>
                    </th>
                    <td class="pb-50">
                      {{geographicCoverage}}
                    </td>
                  </template>
                </tr>
                <tr>
                  <b-skeleton animation="wave" v-if="loading"/>
                  <template v-else>
                    <th class="pb-50">
                      <feather-icon
                          icon="InfoIcon"
                          class="mr-75"
                      />
                      <span class="font-weight-bold">Segmentação Assistencial: </span>
                    </th>
                    <td class="pb-50">
                      {{assistanceSegmentation}}
                    </td>
                  </template>
                </tr>
                <tr>
                  <b-skeleton animation="wave" v-if="loading"/>
                  <template v-else>
                    <th class="pb-50">
                      <feather-icon
                          icon="InfoIcon"
                          class="mr-75"
                      />
                      <span class="font-weight-bold">Coparticipativo?</span>
                    </th>
                    <td class="pb-50 text-capitalize">
                      {{flgCopart === 'S' ? 'Sim' : 'Não'}}
                    </td>
                  </template>
                </tr>
                <tr>
                  <b-skeleton animation="wave" v-if="loading"/>
                  <template v-else>
                    <th class="pb-50">
                      <feather-icon
                          icon="DollarSignIcon"
                          class="mr-75"
                      />
                      <span class="font-weight-bold">Valor do contrato: </span>
                    </th>
                    <td class="pb-50 text-capitalize">
                      {{valuePlan}}
                    </td>
                  </template>
                </tr>
                <tr>
                  <b-skeleton animation="wave" v-if="loading"/>
                  <template v-else>
                    <th class="pb-50">
                      <feather-icon
                          icon="DollarSignIcon"
                          class="mr-75"
                      />
                      <span class="font-weight-bold">Taxa administrativa (titular): </span>
                    </th>
                    <td class="pb-50">
                      R$ 5,00
                    </td>
                  </template>
                </tr>
              </table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <Beneficiaries />
    <BeneficiariesCPT />
  </div>
</template>

<script>
import moment from 'moment';

import ContractService from "@/services/ContractService";
import Beneficiaries from "@/components/Beneficiaries";
import getEndPoint from "@/config/getEndPoint";
import BeneficiariesCPT from "@/components/BeneficiariesCPT";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
  name: "ContractResume",
  components:{
    Beneficiaries,
    BeneficiariesCPT
  },
  mounted() {
    this.loading = true;
    ContractService.getResume().then(resp => {
      this.namePlan = resp.data.nome_plano;
      this.registerANS = resp.data.registro_ans;
      this.flgCopart = resp.data.copart;
      this.acomodation = resp.data.acomodacao;
      this.effectiveDate = moment(resp.data.data_vigencia).format('DD/MM/YYYY')
      this.geographicCoverage = resp.data.abrangencia_geografica;
      this.assistanceSegmentation = resp.data.segmentacao_assistencial;
      this.entityName = resp.data.nome_entidade.length > 50 ? resp.data.nome_entidade.substr(0, 50) + '...' : resp.data.nome_entidade;
      this.valuePlan = parseFloat(resp.data.valor)
          .toLocaleString('pt-BR', { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' });
      this.uuid = resp.data.uuid;
      this.isTrasnfOrPort = resp.data.num_contrato_transf === null && resp.data.codigo_portabilidade === null
      this.loading = false
    }).catch(err => {
      this.loading = false
      this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Oops!',
              icon: 'BellIcon',
              text: 'Ocorreu um erro ao buscar os dados do contrato.',
              variant: 'danger',
            },
          },
          {
            position: 'top-center'
          })
    });
  },
  data(){
    return {
      loading: false,
      effectiveDate: null,
      namePlan: null,
      registerANS: null,
      flgCopart: null,
      numberLifes: null,
      acomodation: null,
      geographicCoverage: null,
      assistanceSegmentation: null,
      entityName: null,
      valuePlan: null,
      uuid: null,
      isTrasnfOrPort: false,
    }
  },
  computed:{
    mountURLProposal() {
      return `${getEndPoint.get()}/contract/${this.uuid}/proposal`;
    },
    mountURLDeclarationHealth(){
      return `${getEndPoint.get()}/contract/${this.uuid}/declaration-health`;
    }
  }
}
</script>

<style scoped>

</style>